module.exports = __webpack_public_path__ + "img/col-bgimage-7.64178954.png";